// extracted by mini-css-extract-plugin
export var styles = "banner-top-module--styles--6J_sd";
export var zzz = "banner-top-module--zzz--PxwUT";